import { SettingsList, SettingsListItem } from "../base";
import { OrganizationSettingsTab } from "./OrganizationSettingTab";

type AccountCardProps = {
  email: string | undefined;
};

export const AccountCard = ({ email }: AccountCardProps) => {
  return (
    <OrganizationSettingsTab title="Account">
      <SettingsList>
        <SettingsListItem
          title={email || "No email"}
          subtitle="Email Address"
          icon={email?.charAt(0)?.toUpperCase() || "U"}
        />
      </SettingsList>
    </OrganizationSettingsTab>
  );
};
